import React, { useContext, useState, useEffect } from 'react'
import * as cam from "@mediapipe/camera_utils"
// import { pMediapipeOptions, pStatus } from "../utils/parameters";
import { Holistic, POSE_CONNECTIONS, FACEMESH_TESSELATION, HAND_CONNECTIONS } from '@mediapipe/holistic/holistic';
//import { Hands  } from '@mediapipe/hands/hands';
//import { Pose } from '@mediapipe/pose/pose';
import {drawConnectors, drawLandmarks } from '@mediapipe/drawing_utils/drawing_utils';
import { useSnackbar } from 'notistack';


const MediapipeContext = React.createContext();

export function useMediapipe() {
    return useContext(MediapipeContext)
}

export function Mediapipe({ children }) {

    const { enqueueSnackbar } = useSnackbar();

    // const idx_kps_pose = [0, 2, 5, 7, 8, 11, 12, 13, 14, 15, 16];
    const idx_kps_pose = [0, 2, 5, 7, 8, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24] 

    const remove_visibility_idx_kps_pose = [18, 20, 22, 17, 19, 21];
    

    const auto_lst_idx_kp_to_check_pose = [15, 17, 19, 16, 18, 20];
    const auto_lst_idx_kp_to_check_hands = [0, 2, 6, 10, 14, 18, 4, 20, 16, 12, 8];

    const num_elements = 61;
    const width_input = 1;
    const height_input = 1;

    // const width_input = 853;
    // const height_input = 640;
    
    let holistic_config  = [0, 0.6, 0.5, 0]; // [modelComplexity, minDetectionConfidence, minTrackingConfidence, showFaceMesh]

    let canvas = null;
    let canvasReference = null;
    let holistic = null;
    let camera = null;

    let activateMediapipe = false;
    let activate_canvas = false;
    let activate_buffer = false;

    let results_holistic = null;
    let data_mediapipe = [];
    let counter_fps_hands = 0;
    let counter_fps_pose = 0;

    let showPose = true;

    function filterVisilityOnResultPose(results){
        for (const index of remove_visibility_idx_kps_pose) {
            try{
                results.poseLandmarks[index].visibility = 0;
            }catch{

            }
        }
    }

    
    function onResultsHolistic(results) {
        results_holistic = results;
        if (results.poseLandmarks !== undefined) {
            counter_fps_hands = counter_fps_hands+1
            if (activate_canvas){
                filterVisilityOnResultPose(results)
                // canvas.save();
                canvas.clearRect(0, 0, canvasReference.width, canvasReference.height);
                // console.log('showPose: '+showPose)
                //canvas.drawImage(results.image, 0, 0, canvasReference.width, canvasReference.height);
                if (showPose == true){
                    drawConnectors(canvas, results.poseLandmarks, POSE_CONNECTIONS,{color: '#00FF00', lineWidth: 0.5});
                    drawLandmarks(canvas, results.poseLandmarks,{color: '#FF0000', lineWidth: 0.5,radius: 1});
                }
                if (holistic_config[3]!==0) drawConnectors(canvas, results.faceLandmarks, FACEMESH_TESSELATION,{color: '#C0C0C070', lineWidth: 1});
                drawConnectors(canvas, results.leftHandLandmarks, HAND_CONNECTIONS,{color: '#CC0000', lineWidth: 0.5});
                drawLandmarks(canvas, results.leftHandLandmarks,{color: '#00FF00', lineWidth: 0.5,radius: 1});
                drawConnectors(canvas, results.rightHandLandmarks, HAND_CONNECTIONS,{color: '#00CC00', lineWidth: 1});
                drawLandmarks(canvas, results.rightHandLandmarks,{color: '#FF0000', lineWidth: 0.5,radius: 0.5});
                // canvas.restore();
                // console.log(results)
            }
            if (activate_buffer){
                const kps_frame = new Array(num_elements).fill([0,0,0,0]);
    
                if (results.poseLandmarks !== undefined) {
                    for (const [idx, idx_mediapipe] of idx_kps_pose.entries()) {
                        kps_frame[idx] = [results.poseLandmarks[idx_mediapipe].x, results.poseLandmarks[idx_mediapipe].y, results.poseLandmarks[idx_mediapipe].z, results.poseLandmarks[idx_mediapipe].visibility];
                    }
                }
                for (let idx = 0; idx < 21; idx++){
                    if (results.leftHandLandmarks !== undefined) {
                        kps_frame[idx+idx_kps_pose.length] = [results.leftHandLandmarks[idx].x, results.leftHandLandmarks[idx].y, results.leftHandLandmarks[idx].z, 1];
                    }
                    if (results.rightHandLandmarks !== undefined) {
                        kps_frame[idx+idx_kps_pose.length+21] = [results.rightHandLandmarks[idx].x, results.rightHandLandmarks[idx].y, results.rightHandLandmarks[idx].z, 1];
                    }
                }
                data_mediapipe = [...data_mediapipe,kps_frame]
            }
        } else {
            canvas.clearRect(0, 0, canvasReference.width, canvasReference.height);
        }
    }

    function clearCanvas(){
        if (canvas !== null){
            canvas.clearRect(0, 0, canvasReference.width, canvasReference.height);
        }
    }

    function mediapipe_getFPS(clear = false){
        //console.log('FPS. Hands: '+counter_fps_hands+' Pose: '+counter_fps_pose)
        const out = [counter_fps_hands, counter_fps_pose]
        if (clear === true){
            counter_fps_hands = 0
            counter_fps_pose = 0
        }
        return out
    }

    function load_camera(video){

        //var timeStampInMs = window.performance && window.performance.now ? window.performance.now() : Date.now();

        if (camera === null){
            camera = new cam.Camera(video, {
                onFrame: async () => { 
                        //console.log(timeStampInMs);
                        if (activateMediapipe) await holistic.send({ image: video });
                    },
                width: video.offsetWidth,
                height: video.offsetHeight
                });
            camera.start()
            console.log(video.offsetWidth)
        }else {
            console.log('camera yet started')
        }
    }


    function load_model_Holistic() {
        if (holistic==null){
            const mpHolistic = window;
            console.log('Load holistic model');
            //holistic =  new Holistic({locateFile: (file) => {return `https://cdn.jsdelivr.net/npm/@mediapipe/holistic@` +`${mpHolistic.VERSION}/${file}`; }});
            // holistic =  new Holistic({locateFile: (file) => {return `assets/mediapipe/holistic/${file}`; }});
            holistic = new Holistic({locateFile: (file) => {return `https://cdn.jsdelivr.net/npm/@mediapipe/holistic/${file}`;}});

            holistic.onResults(onResultsHolistic);
            holistic.setOptions({
                modelComplexity: holistic_config[0],
                smoothLandmarks: true,
                minDetectionConfidence: holistic_config[1],
                minTrackingConfidence: holistic_config[2]
            });

            enqueueSnackbar('Mediapipe model loaded. holistic_config:['+holistic_config+']', { variant: 'success', });

        }else{
            console.log('Holistic model already implemeted')
        }
    }

    function start_Mediapipe(video, canvasRef) {
        console.log('start_Mediapipe')
        canvasReference = canvasRef;
        canvas = canvasReference.getContext('2d')
        load_model_Holistic()
        load_camera(video);
        
        activate_canvas = true;
        
        if (activateMediapipe === false){
            //intervalFPS = setInterval(() => {showFPS()}, 1000);
            activateMediapipe = true;
        }
    }

    function stop_Mediapipe() {
        //activate = false
        console.log('stop_Mediapipe')
        activateMediapipe = false;
        activate_canvas = false;
        clearCanvas();
    }
    
    function out_Mediapipe() {
        //activate = false
        console.log('out_Mediapipe');
        stop_Mediapipe();
        camera = null;
    }

    function mediapipe_obtain_output(setMediapipeData){
        console.log('mediapipe_obtain_output')
        const jsonData = JSON.stringify(data_mediapipe);
        const blob = new Blob([jsonData], { type: 'application/json' });
        const fileData = new File([ blob ], 'data.json');
        setMediapipeData(fileData)

        const bloblurl = URL.createObjectURL(blob);
        console.log('bloblurl: '+bloblurl);
    
        data_mediapipe = []
        //return fileData;
    }

    function mediapipe_recorder(new_state){
        console.log('mediapipe_recorder: '+new_state)
        activate_buffer = new_state
    }

    function get_keypoints_visual_control(){
        const pose_palm = new Array(auto_lst_idx_kp_to_check_pose.length+(auto_lst_idx_kp_to_check_hands.length * 2)).fill(null);

        for (const [index, element] of auto_lst_idx_kp_to_check_pose.entries()) {
            try{
                pose_palm[index] = results_holistic.poseLandmarks[element] 
            }catch {}
            try{
                pose_palm[auto_lst_idx_kp_to_check_pose.length+index] = results_holistic.leftHandLandmarks[element] 
            }catch {}
            try{
                pose_palm[auto_lst_idx_kp_to_check_pose.length+ auto_lst_idx_kp_to_check_hands.length+ index] = results_holistic.rightHandLandmarks[element] 
            }catch {}
        }

        return pose_palm.reverse();
    }


    useEffect(() => {
        console.log('useEffect setShowPose: '+showPose)
    }, [showPose])

    function setShowPose(state){
        console.log('setShowPose: '+showPose)
        showPose = state;
    }

    const value = {
        start_Mediapipe, stop_Mediapipe, out_Mediapipe, mediapipe_obtain_output, mediapipe_recorder, mediapipe_getFPS, get_keypoints_visual_control, setShowPose
    }


    return (
        <MediapipeContext.Provider value={value}>
            {children}
        </MediapipeContext.Provider>
    )

}